import Api from '@/config/api';

export default {
    namespaced: true,
    state: {
        allJobs: [],
        currentPage: 1,
        totalPages: 1,
        pageSize: 20,
        totalJobs: 0,
        loading: false,
    },
    mutations: {
        setJobs(state, jobs) {
            state.allJobs = jobs;
        },
        setPage(state, page) {
            state.currentPage = page;
        },
        setTotalPages(state, total) {   
            state.totalPages = total;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setTotalJobs(state, total) {
            state.totalJobs = total;
        }
    },
    actions: {
        async loadJobs({ commit }, { page = 1, searchKeyword = '', companyIds = null }) {
            try {
                commit('setLoading', true);
                await this._vm.$auth.getToken();
                const params = {
                    jdSearchAnd: searchKeyword,
                    page: page,
                };

                if (Array.isArray(companyIds) && companyIds.length > 0) {
                    params.companyIds = companyIds.join(',');
                }

                const response = await this._vm.axios({
                    method: "get",
                    url: Api.url(Api.endpoints.allJds),
                    params,
                });

                const { jDs, totalPages, totalDocuments } = response.data;
                commit('setJobs', jDs);
                commit('setTotalJobs', totalDocuments);
                commit('setTotalPages', totalPages);
                commit('setPage', page);
                return jDs;
            } catch (err) {
                console.error("Error fetching jobs:", err);
                return [];
            } finally {
                commit('setLoading', false);
            }
        }
    },
    getters: {
        getJobs: state => state.allJobs,
        getCurrentPage: state => state.currentPage,
        getTotalPages: state => state.totalPages,
        getLoading: state => state.loading,
        getTotalJobs: state => state.totalJobs,
    }
}; 